module.exports = __webpack_public_path__ + "assets/img/4-1.5f504587.jpg";